// Load Styles
import "../../../scss/web/announcement/style.scss";

import App from "js/web/shared/app.js";
import { DateRangePicker } from "js/shared/plugins/index.js";

const app = new App();

const searchTextEl = document.getElementById("searchText");
const startDateEl = document.getElementById("startDate");
const endDateEl = document.getElementById("endDate");
const displayDateEl = document.getElementById("displayDate");
const filterButton = document.getElementById("filter");

const DATERANGEPICKER_OPTIONS = {
  drops: "up",
};

const dateRangePicker = new DateRangePicker(
  ".date-range-picker",
  "#startDate",
  "#endDate",
  DATERANGEPICKER_OPTIONS,
  displayDateEl.value,
);

document.addEventListener("DOMContentLoaded", () => {
  app.init();
  dateRangePicker.init();
});

filterButton.addEventListener("click", (e) => {
  e.preventDefault();

  const searchText = searchTextEl.value || "";
  const startDate = startDateEl.value || "";
  const endDate = endDateEl.value || "";
  const url = `/duyurular/ara?searchText=${searchText}&startDate=${startDate}&endDate=${endDate}`;

  window.location.href = url;
});
